module.exports = __webpack_public_path__ + "static/media/title.eb2a36ce.png";